import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/herramientas/presupuestos")({
  beforeLoad: () => {
    throw redirect({ to: "/herramientas/proveedores", statusCode: 301 });
  },
});
